import React, { useState, useEffect, useRef } from "react";
import { graphql } from "gatsby";
import { SiteMetaDataFields } from "../fragments/NodeSiteMetadataFields";
import { WmkSeo } from "wmk-seo";
import { IconBlock as IconBlockComp } from "../components/ui/IconBlock";
import { IconDescriptorQuery } from "../fragments/NodeIconBlockFields";
import { IconBlock } from "../classes/IconBlock";
import CourseGallery from "../components/ui/CourseGallery";
import { VideoCat } from "../classes/VideoCat";
import { VideoCategoryQuery } from "../fragments/NodeVideoCategories";
import { VideoFormQuery } from "../fragments/NodeVideoFormFields";
// import VideoForm from "../components/ui/VideoForm";
import VideoHero from "../components/ui/VideoHero";
import { VideoHeroQuery } from "../fragments/NodeVideoHeroFields";
// import FormPopup from "../components/ui/FormPopup";
import { SeoImageQuery } from "../fragments/NodeImageAssetFields";
import { Img } from "wmk-image";

const IndexPage = ({ data }: { data: IndexPageQuery }) => {
  const [isOpen, setIsOpen] = useState(false);

  let metaImage
  if (data.videoHero.metaImage) {
    metaImage = new Img(data.videoHero.metaImage);
    metaImage.addCrop("ogImage", data.videoHero.metaImage.ogImage);
    metaImage.addCrop("twitterImage", data.videoHero.metaImage.twitterImage);
  }
  else if (data.image.gatsbyImageData) {
    metaImage = new Img(data.image);
    metaImage.addCrop("ogImage", data.image.ogImage);
    metaImage.addCrop("twitterImage", data.image.twitterImage);
  }

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const iconBlockData = new IconBlock(data.iconBlock);
  const videoCats = data.cards.edges.map((vidCat) => {
    return new VideoCat(vidCat.node);
  });
  const videoForm = data.videoForm;
  return (
    <>
      <WmkSeo.Meta
        title={"Home"}
        siteTitle={data.site.siteMetadata.title}
        baseUrl={data.site.siteMetadata.baseUrl}
        slug="/"
        ogImageUrl={metaImage?.src ? metaImage.src : ""}
        twitterImageUrl={metaImage?.url("twitterImage") ? metaImage?.url("twitterImage") : ""}
        twitterHandle="https://twitter.com/WatermarkAgency"
        description={data.site.siteMetadata.description}
      />
      <VideoHero
        videoHeroData={data.videoHero}
        videoForm={videoForm}
        isOpen={isOpen}
        openToggle={toggle}
      />
      <IconBlockComp iconBlockData={iconBlockData} />
      <CourseGallery
        data={videoCats}
        title="Popular Videos"
        homePage
        largeDisplay
        openToggle={toggle}
      />
    </>
  );
};

export default IndexPage;

interface IndexPageQuery {
  site: SiteMetaDataFields;
  image: SeoImageQuery;
  iconBlock: IconDescriptorQuery;
  cards: { edges: { node: VideoCategoryQuery }[] };
  videoForm: VideoFormQuery;
  videoHero: VideoHeroQuery;
}

export const query = graphql`
  {
    site {
      ...NodeSiteMetadata
    }
    image: contentfulAsset(title: { eq: "WMK-Icon" }) {
      ...NodeSeoImageQuery
    }
    iconBlock: contentfulIconDescriptor(blockId: { eq: "You Will Learn" }) {
      ...NodeIconDescriptorFields
    }
    cards: allContentfulVideoCategory(
      filter: {
        title: {
          in: [
            "Maximize Your CRM"
            "Launch a Powerful CRM"
            "Put Your Sales Team First"
          ]
        }
      }
    ) {
      edges {
        node {
          ...NodeVideoCategoryFields
        }
      }
    }
    videoForm: contentfulVideoForm(contentfulid: { eq: "CRM" }) {
      ...NodeVideoFormFields
    }
    videoHero: contentfulVideoHero(contentfulid: { eq: "CRM Hero" }) {
      ...NodeVideoHeroFields
    }
  }
`;
